import React from 'react';
// import DirectoryTabs from './DirectoryTabs';
import { ToastContainer } from 'react-toastify';
import MedicalCampTab from './MedicalCampTab';

const Result = () => {
  return (
    <>
      <ToastContainer />
      <div className="user-section">
        <MedicalCampTab />
      </div>
    </>
  );
};

export default Result;
